<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <div class="form-group">
            <label>Filter By Group</label>
            <b-select
              v-model="filter.group"
              :options="filterUserGroups"
              @change="onFilterChanged"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-checkbox
            id="status"
            v-model="filter.status"
            name="status"
            value="1"
            unchecked-value="0"
            switch
            @change="onFilterChanged"
          >
            <strong>Show Active Only?</strong>
          </b-form-checkbox>
          <br>
        </b-col>

        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Agent
          </b-button>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{
            tableSettings.currentPage * tableSettings.perPage -
              tableSettings.perPage +
              (data.index + 1)
          }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active === 1 ? "Yes" : "No" }}
        </template>

        <template #cell(notification)="data">
          {{ data.item.notification === 1 ? "Yes" : "No" }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-agent-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      @ok="onConfirmAction"
    >
      <ValidationObserver ref="form">
        <form
          role="form"
          novalidate
        >
          <ValidationProvider
            #default="{ errors }"
            name="email"
            vid="email"
            rules="required|email|max:100"
          >
            <b-form-group>
              <label for="email">Email</label>
              <b-input
                id="email"
                v-model="user.email"
                type="email"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter email"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="first name"
            vid="first_name"
            rules="required|max:50"
          >
            <b-form-group>
              <label for="first_name">First Name</label>
              <b-input
                id="first_name"
                v-model="user.first_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter first name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="middle name"
            vid="middle_name"
            rules="max:50"
          >
            <b-form-group>
              <label for="middle_name">Middle Name</label>
              <b-input
                id="middle_name"
                v-model="user.middle_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter middle name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="last name"
            vid="last_name"
            rules="required|max:50"
          >
            <b-form-group>
              <label for="last_name">Last Name</label>
              <b-input
                id="last_name"
                v-model="user.last_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter last name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password"
            vid="password"
            :rules="passwordRule"
          >
            <b-form-group>
              <label
                for="password"
              >Password
                <span
                  v-if="state.editing"
                >(Leave blank when not changing password)</span></label>
              <b-input
                id="password"
                v-model="user.password"
                type="password"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter password"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password confirmation"
            vid="password_confirmation"
            :rules="passwordConfirmationRule"
          >
            <b-form-group>
              <label
                for="password_confirmation"
              >Password Confirmation
                <span
                  v-if="state.editing"
                >(Leave blank when not changing password)</span></label>
              <b-input
                id="password_confirmation"
                v-model="user.password_confirmation"
                type="password"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter password confirmation"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="group"
            vid="group"
            rules="required"
          >
            <div class="form-group">
              <label for="group">Group</label>
              <b-form-select
                id="group"
                v-model="user.group"
                :options="list.user_groups"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Group --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="user.active"
              switch
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
            >
              Is Active?
            </b-form-checkbox>
            <b-form-checkbox
              id="notification"
              v-model="user.notification"
              class="mt-2"
              switch
              name="notification"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
            >
              Notification
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? "Update Record" : "Save Record" }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, SupervisorAgentService, SharedListService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'SupervisorAgents',

  middleware: ['auth', 'supervisor'],

  metaInfo () {
    return {
      title: 'Agents'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      filter: {
        group: 'All',
        status: 0
      },
      list: {
        user_groups: []
      },
      user: {
        id: '',
        active: 0,
        email: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        password: '',
        password_confirmation: '',
        role: 'agent',
        notification: 0,
        group: null
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'email', sortable: true },
          { key: 'first_name', sortable: true },
          { key: 'middle_name', sortable: true },
          { key: 'last_name', sortable: true },
          { key: 'group_name' },
          { key: 'active', label: 'IS ACTIVE?' },
          { key: 'notification' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.state.editing ? 'Edit Agent' : 'Add Agent'
    },

    passwordRule () {
      return `${
          this.state.editing ? '' : 'required|'
        }min:8|confirmed:password_confirmation`
    },

    passwordConfirmationRule () {
      return `${this.state.editing ? '' : 'required'}`
    },

    filterUserGroups () {
      return [{ value: 'All', text: 'All' }].concat(this.list.user_groups)
    }
  },

  watch: {
    'user.active' (value) {
      if (parseInt(value) === 0) {
        this.user.notification = 0
      }
    }
  },

  mounted () {
    core.index()
    this.getUserGroups()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await SupervisorAgentService.get(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            filter_group: this.filter.group,
            filter_status: this.filter.status
          })
        )
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getUserGroups () {
      await SharedListService.getUserGroups().then(({ data }) => {
        this.list.user_groups = data.map(({ id, group_name }) => ({
          text: group_name,
          value: id
        }))
      })
    },

    onShowAddForm () {
      this.state.editing = false
      this.user.id = 0
      this.user.active = 1
      this.user.email = ''
      this.user.first_name = ''
      this.user.middle_name = ''
      this.user.last_name = ''
      this.user.password = ''
      this.user.password_confirmation = ''
      this.user.group = null
      this.user.notification = 1
      this.$bvModal.show('modal-agent-form')
    },

    onShowEditForm (item) {
      this.state.editing = true
      this.user.id = item.id
      this.user.active = item.active
      this.user.email = item.email
      this.user.first_name = item.first_name
      this.user.middle_name = item.middle_name
      this.user.last_name = item.last_name
      this.user.password = ''
      this.user.password_confirmation = ''
      this.user.group = item.group_id
      this.user.notification = item.notification
      this.$bvModal.show('modal-agent-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          let title = 'Do you really want to create user?'

          if (this.state.editing) {
            title = 'Do you really want to save changes?'
          }

          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: title,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              if (!this.state.editing) {
                return this.onFormPostSubmit()
              } else {
                return this.onFormPutSubmit()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oppss! There were problem with your inputs.',
            {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger'
            }
          )
        }
      })
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    },

    async onFormPostSubmit () {
      return new Promise((resolve, reject) => {
        this.state.busy = true
        SupervisorAgentService.post(this.user)
          .then(response => {
            this.state.busy = false
            this.$bvModal.hide('modal-agent-form')
            this.$swal
              .fire({
                icon: 'success',
                title: 'Successful',
                text: response.data.message,
                confirmButtonColor: '#06C270',
                confirmButtonText: 'Dismiss'
              })
              .then(() => {
                this.$refs.table.refresh()
              })
          })
          .catch(error => {
            this.state.busy = false
            if (error instanceof AxiosError) {
              if (error.code === 422) {
                this.$refs.form.setErrors(error.message)
                resolve(error)
              }
            }
          })
      })
    },

    async onFormPutSubmit () {
      return new Promise((resolve, reject) => {
        this.state.busy = true
        SupervisorAgentService.put(this.user)
          .then(({ data }) => {
            this.state.busy = false
            this.$bvModal.hide('modal-agent-form')
            this.$swal
              .fire({
                icon: 'success',
                title: 'Successful',
                text: data.message,
                confirmButtonColor: '#06C270',
                confirmButtonText: 'Dismiss'
              })
              .then(() => {
                const row = _.find(this.$refs.table.localItems, {
                  id: data.user.id
                })
                row.email = data.user.email
                row.first_name = data.user.first_name
                row.middle_name = data.user.middle_name
                row.last_name = data.user.last_name
                row.role = data.user.role
                row.active = data.user.active
                row.group_name = data.user.user_group.group_name
                row.notification = data.user.notification
                row.updated_at = data.cluster.updated_at
              })
          })
          .catch(error => {
            this.state.busy = false
            if (error instanceof AxiosError) {
              if (error.code === 422) {
                this.$refs.form.setErrors(error.message)
                resolve(error)
              }
            }
          })
      })
    }
  }
}
</script>
